import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import moment from "moment-timezone";

const firebaseConfig = {
    apiKey: "AIzaSyAr-uNbcpDoOBQghaCOBU5z_tue1YVbWNw",
    authDomain: "bizbabyapp-e757e.firebaseapp.com",
    projectId: "bizbabyapp-e757e",
    storageBucket: "bizbabyapp-e757e.firebasestorage.app",
    messagingSenderId: "797965970734",
    appId: "1:797965970734:web:5c90f453ccc19eb84ddebf",
    measurementId: "G-PNEXM0JDBB"
};

export default class FcmNotify{
    static #app;
    static #messaging;
    static #isInit = false
    static #VAPID = 'BCkTGB1malQrPa67AreGmcrCTTXD55Jr7UqT8rVgv9o89T7ta9qRwZD46isOjgwvHWsh-5ewbSJBScnpn1W60K0'
    static #TOKEN = null
    static #prevTitle = ''
    static #timeout = null
    static #popupTimeout = null
    static #workerChannel = null
    static #activeCockpitWindow
    static #checkActiveTokenInterval = null
    static #checkClosePopupInterval = null
    static #pageKey
    static #isMobile = false
    static #TYPES={
        WAKE_UP:1,
        INCOMING_CALL:2,
        DECLINE_CALL:3,
        MESSAGE:4,
        ADVERT:5,
        CHANGE_PERMISSION:6,
        AVAILABLE_CALL:7,
        CHANGE_USER_ACTIVE:8,
    }

    static #DEVICE_TYPES = {
        PC:1,
        PHONE:2
    }

    static get isInit(){
        return this.#isInit
    }

    static get messaging(){
        return this.#messaging
    }

    static get app(){
        return this.#app
    }

    static get TYPES(){
        return this.#TYPES
    }

    static get DEVICE_TYPE(){
        return this.#DEVICE_TYPES
    }

    static get TOKEN(){
        return this.#TOKEN ? this.#TOKEN : localStorage.getItem('firebaseToken')
    }
    
    static async init(){
        if(/\/website-builder\/.*design(?:\/|$)/.test(window.location.pathname))
            return
        console.log('INITIALIZATION!!!')
        if(this.#isInit)
            return
        const customerVerified = document.querySelector('meta[name=customer-verified]'); //отключение для кастомер кабинета чтоб не было ошибок
  
        let countMobile = 'ontouchstart' in window ? 1 : 0; //отключение для мобильных устройств по нескольким критериям
        countMobile+= window.matchMedia("only screen and (max-width: 760px)").matches ? 1 : 0
        countMobile+= window.screen.orientation.type == 'portrait-primary' ? 1 : 0
        if(customerVerified || countMobile >=2)
            return
        const request = await fetch(`${location.origin}/check-call-permission`);
        // Before a company is selected, the organisation middleware answers
        // with a redirect page instead of JSON — treat that as "not resolved".
        let response = null;
        if (request.ok && (request.headers.get('content-type') || '').includes('json')) {
            response = await request.json();
        }
        const resolved = response?.success && response?.resolved;

        console.log('ISSET NOTIFICATION:', 'Notification' in window)
        //console.log('ORGANISATION ID:', window.organisation_id)
        console.log('RESOLVED: ', resolved)

        if('Notification' in window && window.organisation_id && resolved){
            this.#workerChannel = new BroadcastChannel('serviceChannel');
            this.#workerChannel.onmessage = (ev)=>{
                console.log('SEND DATA FROM SERVICE WORKER:', ev.data)
                if(ev?.data?.type == 'accept-call' && ev?.data?.id){
                    if(this.#activeCockpitWindow && typeof this.#activeCockpitWindow?.close == 'function' && window.name!='parent-cockpit_'+ev?.data?.id){
                        this.#activeCockpitWindow.close()
                        this.#activeCockpitWindow = null
                        window.name = ''
                    }
                }else if(ev?.data?.type == 'background-message' && ev?.data?.notify){
                    const notify = ev?.data?.notify
                    switch(Number(notify?.type)){
                        case FcmNotify.TYPES.INCOMING_CALL:
                            this.showIncomingCallNotify(notify)
                            localStorage.setItem('activeNotify', JSON.stringify(notify))
                            break
                        case FcmNotify.TYPES.DECLINE_CALL:
                            this.hideIncomingCallNotify(notify?.identity)
                            break
                    }
                }
            }
            this.setAdditionalHandlers()
            this.#app = initializeApp(firebaseConfig);
            this.#messaging = getMessaging(this.#app);
            const browser = this.detectBrowser()
            if((browser == 'Firefox' || browser == 'Safari') && Notification.permission != 'granted' && !localStorage.getItem('isReqPermissionNotify')){
                if($('#notify-permissions-modal').length){
                    $('#notify-permissions-modal').modal('show')
                    $('#notify-permissions-modal #decline-permission').off('click').on('click', ()=>{
                        console.warn("Notification permission denied!")
                        $('#notify-permissions-modal').modal('hide')
                        localStorage.setItem('isReqPermissionNotify', '1')
                    })
                    $('#notify-permissions-modal #accept-permission').off('click').on('click', ()=>{
                        $('#notify-permissions-modal').modal('hide')
                        localStorage.setItem('isReqPermissionNotify', '1')
                        this.subscribe()
                    })
                }
            }else{
                this.subscribe();
            }
        }
    }

    static setNavCallBtnsClick(){
        $('#quick-call-btn, #call-msg-center-btn').on('click', ev => {
            console.log('NAV BTN CLICK')
            if(typeof window.name == 'string' && /^parent-cockpit/.test(window.name)){
                if (this.#activeCockpitWindow && !this.#activeCockpitWindow?.closed) 
                    this.openOldWindow(ev)
                else{
                    this.openNewWindow(ev)
                }
            }else{
                this.openNewWindow(ev)
            }
        })
        $('#available-switch-btn').on('click', function () {
            $('#available-toggle').prop('checked', !$('#available-toggle').prop('checked'))
            if($('#call-toggle').length){
                $('#call-toggle').prop('checked', $('#available-toggle').is(':checked'))
                $('#call-toggle').trigger('click')
            }else{
                // v2 engine: availability lives in agent_presence (+ this
                // device's FCM token is armed/disarmed for the call toasts).
                $.ajax({
                    type: 'POST',
                    url: '/cockpit/v2/presence',
                    contentType: 'application/json',
                    data: JSON.stringify({
                        available: $('#available-toggle').is(':checked'),
                        fcm_token: FcmNotify.TOKEN
                    }),
                    headers: { 'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.content || '' }
                }).fail(function (jqXHR, exception) {
                    $('#available-toggle').prop('checked', !$('#available-toggle').prop('checked'))
                });
            }
            if($('#available-toggle').is(':checked')){
                $('.dropdown-call-counter').removeClass('d-none')
                $('.not-available-icon').addClass('d-none')
            }else{
                $('.dropdown-call-counter').addClass('d-none')
                $('.not-available-icon').removeClass('d-none')
            }
        });
    }

    static openNewWindow(ev){
        this.setCockpitPopupActiveCallback()
        let key = this.randKey()
        window.name = "parent-cockpit_" + key
        
        if (ev?.currentTarget?.id == 'call-msg-center-btn') {
            this.#activeCockpitWindow = window.open(`${window.location.origin}/cockpit`, 'popup-cockpit_' + key);
        } else {
            this.#activeCockpitWindow = window.open(`${window.location.origin}/cockpit`, 'popup-cockpit_' + key, `width=435,height=880,left=${screen.width - 470},top=${(screen.height - 880) / 2 - 20},toolbar=no,resilocation=no,menubar=no,status=no,popup=yes,resizable=no`);
        }
        console.log('OPEN NEW WINDOW: ', this.#activeCockpitWindow)

        let instances = localStorage.getItem('instances')
        instances = instances ? Number(instances) : 0
        instances = instances < 0 ? 0 : instances
        localStorage.setItem('instances', instances + 1)
        instances = localStorage.getItem('callCenterInstances')
        instances = instances ? Number(instances) + 1 : 1
        localStorage.setItem('callCenterInstances', instances)
        
        clearInterval(this.#checkClosePopupInterval)

        this.#checkClosePopupInterval = setInterval(()=>{
            if(this.#activeCockpitWindow.closed){
                let instances = localStorage.getItem('instances')
                if (instances) {
                    instances = Number(instances) - 1;
                    instances = instances < 0 ? 0 : instances
                    localStorage.setItem('instances', instances)
                    if (instances === 0) {
                        console.log('ALL_PAGES_CLOSED')
                        this.setNoActiveServerToken()
                        localStorage.removeItem('isSendToken')
                    }
                }
                instances = localStorage.getItem('callCenterInstances')
                instances = instances ? Number(instances) - 1 : 0
                instances = instances < 0 ? 0 : instances
                localStorage.setItem('callCenterInstances', instances)
                if (typeof window.setActiveCockpitPopup == 'function') {
                    window.setActiveCockpitPopup(false, 'popup-cockpit_' + key)
                }
                let keys = localStorage.getItem('pageKeys')
                keys = keys ? JSON.parse(keys) : []
                keys = keys.filter(el => el != this.#pageKey)
                localStorage.setItem('pageKeys', JSON.stringify(keys))
                if (this.#checkActiveTokenInterval) {
                    clearInterval(this.#checkActiveTokenInterval)
                    if (keys.length) {
                        localStorage.setItem('setCheckActiveTokenInterval', keys[0])
                    } else {
                        localStorage.removeItem('setCheckActiveTokenInterval')
                        this.setNoActiveServerToken()
                        localStorage.removeItem('isSendToken')
                    }
                }
                clearInterval(this.#checkClosePopupInterval)
            }
        },100)

        this.#workerChannel.postMessage({ type: 'accept-call', id: key })
        if (ev?.currentTarget?.id == 'quick-call-btn' && this.#activeCockpitWindow?.document) {
            this.#activeCockpitWindow.addEventListener('load', (ev) => {
                setTimeout(() => {
                    if (typeof this.#activeCockpitWindow?.showQuickCall === 'function')
                        this.#activeCockpitWindow?.showQuickCall()
                }, 500)
            }, false)
        }
    }
    static openOldWindow(ev){
        console.log('OPEN OLD WINDOW')
        let arr = window.name.split('_')
        this.#activeCockpitWindow = window.open('', 'popup-cockpit_' + arr[1]);
        this.#activeCockpitWindow.focus()
        if (ev?.currentTarget?.id == 'quick-call-btn' && this.#activeCockpitWindow?.document) {
            if (typeof this.#activeCockpitWindow?.showQuickCall === 'function')
                this.#activeCockpitWindow?.showQuickCall()
        }
    }

    static detectBrowser() {
        const userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf('firefox') != -1) {
            return 'Firefox';
        } else if (userAgent.indexOf('chrome') != -1) {
            return 'Chrome';
        } else if (userAgent.indexOf('safari') != -1) {
            return 'Safari';
        } else if (userAgent.indexOf('opera') != -1 || userAgent.indexOf('opr') != -1) {
            return 'Opera';
        } else if (userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {
            return 'Internet Explorer';
        } else {
            return 'Unknown';
        }
    }

    static async setNoActiveServerToken(){
        const token = localStorage.getItem('firebaseToken');
        if(token && window?.organisation_id && window?.user_id){
            $.ajax({
                url: `${location.origin}/set-no-active-fcm-token`,
                method: 'POST',
                dataType: 'json',
                data: {
                    fcm_token:token,
                    organisation_id:window.organisation_id,
                    user_id:window.user_id
                },  
                success: response=>{
                    if(response?.success)
                        console.log('SET NO ACTIVE SERVER FCM_TOKEN')
                },
                error: err=>{
                    console.error(err)
                }
            }); 
        }
    }

    static setCockpitPopupActiveCallback(){
        window.setActiveCockpitPopup = (active, key)=>{
            if(active){
                let arr = key.split('_')
                window.name = 'parent-cockpit_'+arr[1]
                this.#activeCockpitWindow = window.open('', key);
                this.#activeCockpitWindow.blur()
                window.focus()
                console.log('ACTIVE POPUP')
            }else{
                this.#activeCockpitWindow = null
                window.name = ''
                console.log('DISACTIVE POPUP')
            }
        }
    }

    static setCockpitParentActiveCallback(){
        window.setActiveCockpitParent = (active) => {
            if(active)
                clearTimeout(this.#popupTimeout)
            else
                this.#popupTimeout = setTimeout(()=>window.close(),10000)
        }
    }

    static setShowQuickCall(){
        console.log('SET SHOW QUICK CALL')
        window.showQuickCall = () =>{
            let modal = $(document.body).find('#quick-call-modal')
            console.log('MODAL: ', modal?.length)
            if(modal.length)
                modal.modal('show')
        }
    }

    static setAcceptCallHandler(){
        window.acceptCallHandler = (data, identity) =>{
            console.log('DATA CALLERS:', data)
            console.log('IDENTITY: ', identity)
            console.log('DISPATCH ACCEPT CALL HANDLER')

            // v2 engine: the FCM identity is the session conference name
            // (bbcc-{org}-{uuid}) — claim the session directly through the
            // CallDock (rings this device, auto-accepts on arrival).
            if (/^bbcc-/.test(String(identity)) && window.CallDock) {
                const uuid = String(identity).replace(/^bbcc-\d+-/, '')
                window.CallDock.expectSession(uuid)
                window.CallDock.claim(uuid)
                return
            }

            const observer = new MutationObserver((mutation)=>{
                const btn = $($('.queue-call-list')[0]).find(`.btn.call-modal[data-identity=${identity}]`)
                if(btn.length){
                    $('#modal-call').one('shown.bs.modal', function (e) {
                        $('#modal-call .wait-call').trigger('click')
                    });
                    btn.trigger('click')
                    observer.disconnect()
                }
            })
            observer.observe($('.queue-call-list')[0], {subtree:true, childList:true})
        }
    }

    static randKey(){
        return (Math.random()+1).toString(36)
    }

    static async subscribe() {
        try{
            const permission = await Notification.requestPermission();
            if(permission === 'granted'){
                const token = await getToken(this.#messaging, { vapidKey: this.#VAPID })
                if(token){
                    this.#TOKEN = token
                    localStorage.setItem('firebaseToken',token);
                    if(window?.organisation_id)
                        this.sendTokenToServer(token)
                    this.#isInit = true;
                    this.setOnMessage()
                    this.setNavCallBtnsClick()
                }else{
                    throw new Error("Couldn't get a firebase token")
                }
            }else{
                console.warn("Notification permission denied!")
            }
        }catch(err){
            FcmNotify.funcChangeBtns('denied', true)
            $('#call-btn-notify-declined').attr('data-placeholder', 'The notification service was not started.')
            console.error(err)
        }
    }

    static showIncomingCallNotify(notify){
        if($('#call-notify-template').length){
            let newNotify = $('#call-notify-template').clone()
            newNotify.attr('data-identity', notify?.identity)
            newNotify.find('.notify-accept-call-btn').data('identity', notify?.identity)
            newNotify.find('.notify-decline-call-btn').data('identity', notify?.identity)
            newNotify.find('.hide-call-btn').data('identity', notify?.identity)
            newNotify.attr('id', null)

            const contactName = String(notify?.contactName || '').trim()
            const fromPhone = String(notify?.fromPhone || '').trim()
            const contactLooksLikePhone = contactName !== ''
                && !/[a-z]/i.test(contactName)
                && contactName.replace(/\D/g, '').length >= 7
            const displayName = contactName && !contactLooksLikePhone
                ? contactName
                : 'Unknown caller'
            const displayPhone = fromPhone || (contactLooksLikePhone ? contactName : '')
            const nameParts = displayName === 'Unknown caller'
                ? []
                : displayName.split(/\s+/).filter(Boolean)
            const initials = nameParts.length
                ? `${nameParts[0][0] || ''}${nameParts.length > 1 ? nameParts[nameParts.length - 1][0] || '' : ''}`.toUpperCase()
                : '+1'

            newNotify.find('.call-notify-name').text(displayName)
            newNotify.find('.call-notify-phone').text(displayPhone || 'Phone number unavailable')
            newNotify.find('.call-notify__avatar').text(initials)
            newNotify.attr('aria-label', `Incoming call from ${displayName}${displayPhone ? `, ${displayPhone}` : ''}`)
            if(!$('#call-notify-container').hasClass('active'))
                $('#call-notify-container').addClass('active')
            $('#call-notify-container').prepend(newNotify)
            newNotify.removeClass('d-none')
            setTimeout(() => newNotify.addClass('show'), 100)
            $('#call-notify-container #notify-sound')[0].play()
            clearInterval(this.#timeout)
            this.#prevTitle = document.title;
            this.#timeout = setInterval(()=>{
                if(document.title != '***INCOMING CALL***')
                    document.title='***INCOMING CALL***'
                else
                    document.title='*******************'
            },1000)  
        }else{
            console.error(`CALL NOTIFY BLOCK DOESN'T EXIST!`)
        }
    }

    static hideIncomingCallNotify(identity){
        console.log('IDENTITY: ', identity)
        if($(`.call-notify[data-identity="${identity}"]`).length){
            $(`.call-notify[data-identity="${identity}"]`).removeClass('show')
            setTimeout(()=>{
                $(`.call-notify[data-identity="${identity}"]`).remove()
                if(!$('#call-notify-container').find('.call-notify').length)
                    $('#call-notify-container').removeClass('active')
            },500)
        }
        clearInterval(this.#timeout)
        if(this.#prevTitle.length)
            document.title = this.#prevTitle
        this.#prevTitle = ''
        localStorage.removeItem('activeNotify')
    }

    static async rejectCallNotify(identity){
        // v2 sessions decline through the engine (caller goes to the org's
        // missed-call fallback instead of a hard hangup).
        const isV2 = /^bbcc-/.test(String(identity))
        const url = isV2
            ? `${location.origin}/cockpit/v2/calls/${String(identity).replace(/^bbcc-\d+-/, '')}/decline`
            : `${location.origin}/cockpit/reject-call`
        let request = await fetch(url, {
            method: 'POST',
            body: JSON.stringify({ identity }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.content || ''
            },
            credentials: 'same-origin'
        })
        const result = await request.json();
        return (result?.success || result?.ok) ? true : false
    }

    static setOnMessage(){
        try{
            if(!this.#isInit)
                throw new Error("Fcm notify has not been initialized!")
            $('body').off('click', '.call-notify .notify-decline-call-btn')
            .on('click', '.call-notify .notify-decline-call-btn', ev=>{
                this.hideIncomingCallNotify($(ev.currentTarget).data('identity'))
                this.rejectCallNotify($(ev.currentTarget).data('identity'))
            })
            $('body').off('click', '.call-notify .hide-call-btn')
            .on('click', '.call-notify .hide-call-btn', ev=>{
                this.hideIncomingCallNotify($(ev.currentTarget).data('identity'))
            })
            $('body').off('click', '.call-notify .notify-accept-call-btn')
            .on('click', '.call-notify .notify-accept-call-btn', ev=>{
                const btn = $(ev.currentTarget)
                const container = $(btn.parents('.call-notify')[0])
                const updateHandler = event =>{
                    console.log("ACTIVE HANDLER: ", this.#activeCockpitWindow?.acceptCallHandler === 'function')
                    if(typeof this.#activeCockpitWindow?.acceptCallHandler !== 'function')
                        return
                    this.#activeCockpitWindow.removeEventListener('update-new-calls', updateHandler)
                    this.#activeCockpitWindow.acceptCallHandler(event.detail, container.attr('data-identity'))
                }
                if(typeof window.name == 'string' && /^parent-cockpit/.test(window.name)){
                    this.openOldWindow(null)
                    this.#activeCockpitWindow.addEventListener('update-new-calls', updateHandler)
                }else{
                    this.openNewWindow(null)
                    this.#activeCockpitWindow.addEventListener('update-new-calls', updateHandler)
                }
                this.hideIncomingCallNotify(container.attr('data-identity'))
            })
            onMessage(this.#messaging, notify=>{
                console.log("NOTIFICATION: ", notify)
                switch(Number(notify?.data?.type)){
                    case FcmNotify.TYPES.INCOMING_CALL:
                        this.showIncomingCallNotify(notify?.data)
                        localStorage.setItem('activeNotify', JSON.stringify(notify?.data))
                        break
                    case FcmNotify.TYPES.DECLINE_CALL:
                        this.hideIncomingCallNotify(notify?.data?.identity)
                        break
                }
            })
            console.log('SET ON MESSAGE')
            return true
        }catch(err){
            console.error(err)
            return false
        }
    }

    static funcChangeBtns(state, isChange = false) {
        console.log('STATE: ', state)
        if (state == 'granted') {
            $('#call-btn-notify-declined').addClass('d-none')
            $('#dropdown-call-btn').removeClass('d-none')
            if ($('#available-toggle').is(':checked')) {
                $('.dropdown-call-counter').removeClass('d-none')
                $('.not-available-icon').addClass('d-none')
            } else {
                $('.dropdown-call-counter').addClass('d-none')
                $('.not-available-icon').removeClass('d-none')
            }
        } else {
            $('#call-btn-notify-declined').removeClass('d-none')
            $('#dropdown-call-btn').addClass('d-none')
            $('.dropdown-call-counter').addClass('d-none')
            $('.not-available-icon').addClass('d-none')
        }
        if (isChange && state == 'denied') {
            FcmNotify.setNoActiveServerToken()
            localStorage.removeItem('isSendToken')
        }
    }

    static setAdditionalHandlers(){
        console.log('SET ADDITIONAL HANDLERS')
        const identifiers = [
            '#logout-btn',
            '.switch-company-menu-row',
            '#select-org-btn'
        ]
        for(let id of identifiers){
            if($(id).length)
                $(id).on('click',()=>{
                    FcmNotify.setNoActiveServerToken()
                    localStorage.removeItem('isSendToken')
                    console.log('DELETE IS SEND TOKEN')
                })
        }
        try{
            let activeNotify = localStorage.getItem('activeNotify')
            if (activeNotify) {
                activeNotify = JSON.parse(activeNotify)
                console.log('ACTIVE NOTIFY: ', activeNotify)
                this.showIncomingCallNotify(activeNotify)
            }
        }catch(err){
            console.error(err)
        }
        window.addEventListener('storage', event =>{
            if(event.storageArea != localStorage) return
            if(event.key == 'activeNotify' && event.newValue == null){
                let oldNotify = JSON.parse(event.oldValue)
                console.log('OLD NOTIFY: ', oldNotify)
                this.hideIncomingCallNotify(oldNotify?.identity)
            }
            if(event.key == 'availableCall' && event.newValue!=null){
                if($('#available-toggle').length)
                    $('#available-toggle').prop('checked', event.newValue == '1')
                if($('#call-toggle').length)
                    $('#call-toggle').prop('checked', event.newValue == '1')
            }
            if(event.key == 'setCheckActiveTokenInterval' && event.newValue == this.#pageKey){
                console.log('SET CHECK ACTIVE TOKEN INTERVAL WITH MY KEY')
                clearInterval(this.#checkActiveTokenInterval)
                this.#checkActiveTokenInterval = setInterval(() => {
                    let lifetime = getCookie('bizbaby_session_lifetime')
                    if (lifetime === undefined || (!isNaN(Number(lifetime)) && moment().unix() >= Number(lifetime))) {
                        FcmNotify.setNoActiveServerToken()
                        localStorage.removeItem('isSendToken')
                    }
                    console.log('TICK INTERVAL')
                }, 5000)
            }
        })
        
        if (!/^popup-cockpit/.test(window?.name)) {
            let instances = localStorage.getItem('instances')
            instances = instances ? Number(instances) : 0
            instances = instances < 0 ? 0 : instances
            localStorage.setItem('instances', instances + 1)
            if (/^\/cockpit/.test(location.pathname)) {
                instances = localStorage.getItem('callCenterInstances')
                instances = instances ? Number(instances) + 1 : 1
                localStorage.setItem('callCenterInstances', instances)
            }
        }
        
        if (typeof window.name == 'string' && /^parent-cockpit/.test(window.name)) {
            this.setCockpitPopupActiveCallback()
            let arr = window.name.split('_')
            const keyNamePage = arr[1]
            this.#activeCockpitWindow = window.open('', 'popup-cockpit_' + keyNamePage);
            this.#activeCockpitWindow.blur()
            window.focus()
            if (this.#activeCockpitWindow && typeof this.#activeCockpitWindow.setActiveCockpitParent == 'function') {
                this.#activeCockpitWindow.setActiveCockpitParent(true)
            }
            if(this.#activeCockpitWindow){
                clearInterval(this.#checkClosePopupInterval)
                this.#checkClosePopupInterval = setInterval(() => {
                    if (this.#activeCockpitWindow.closed) {
                        let instances = localStorage.getItem('instances')
                        if (instances) {
                            instances = Number(instances) - 1;
                            instances = instances < 0 ? 0 : instances
                            localStorage.setItem('instances', instances)
                            if (instances === 0) {
                                console.log('ALL_PAGES_CLOSED')
                                this.setNoActiveServerToken()
                                localStorage.removeItem('isSendToken')
                            }
                        }
                        instances = localStorage.getItem('callCenterInstances')
                        instances = instances ? Number(instances) - 1 : 0
                        instances = instances < 0 ? 0 : instances
                        localStorage.setItem('callCenterInstances', instances)
                        if (typeof window.setActiveCockpitPopup == 'function') {
                            window.setActiveCockpitPopup(false, 'popup-cockpit_' + keyNamePage)
                        }
                        let keys = localStorage.getItem('pageKeys')
                        keys = keys ? JSON.parse(keys) : []
                        keys = keys.filter(el => el != this.#pageKey)
                        localStorage.setItem('pageKeys', JSON.stringify(keys))
                        if (this.#checkActiveTokenInterval) {
                            clearInterval(this.#checkActiveTokenInterval)
                            if (keys.length) {
                                localStorage.setItem('setCheckActiveTokenInterval', keys[0])
                            } else {
                                localStorage.removeItem('setCheckActiveTokenInterval')
                                this.setNoActiveServerToken()
                                localStorage.removeItem('isSendToken')
                            }
                        }
                        clearInterval(this.#checkClosePopupInterval)
                    }
                }, 100)
            }
        }

        if (typeof window.name == 'string' && /^popup-cockpit/.test(window.name)) {
            this.setCockpitParentActiveCallback()
            this.setShowQuickCall()
            this.setAcceptCallHandler()
            if (typeof window?.opener?.setActiveCockpitPopup == 'function') {
                window.opener?.setActiveCockpitPopup(true, window.name)
            }
        }
  
        if(!/^popup-cockpit/.test(window?.name)){
            console.log('ADD BEFORE UNLOAD FOR NO POPUP WINDOW')
            window.addEventListener('beforeunload', (ev) => {
                let instances = localStorage.getItem('instances')
                if (instances) {
                    instances = Number(instances) - 1;
                    instances = instances < 0 ? 0 : instances
                    localStorage.setItem('instances', instances)
                    if (instances === 0) {
                        console.log('ALL_PAGES_CLOSED')
                        this.setNoActiveServerToken()
                        localStorage.removeItem('isSendToken')
                    }
                }
                if (/^\/cockpit/.test(location.pathname)) {
                    instances = localStorage.getItem('callCenterInstances')
                    instances = instances ? Number(instances) - 1 : 0
                    instances = instances < 0 ? 0 : instances
                    localStorage.setItem('callCenterInstances', instances)
                }
                if (typeof window.name == 'string' && /^parent-cockpit/.test(window.name)) {
                    if (this.#activeCockpitWindow && typeof this.#activeCockpitWindow.setActiveCockpitParent == 'function') {
                        this.#activeCockpitWindow.setActiveCockpitParent(false)
                    }
                }
                if (typeof window.name == 'string' && /^popup-cockpit/.test(window.name)) {
                    if (typeof window?.opener?.setActiveCockpitPopup == 'function') {
                        window.opener?.setActiveCockpitPopup(false, window.name)
                    }
                }
                let keys = localStorage.getItem('pageKeys')
                keys = keys ? JSON.parse(keys) : []
                keys = keys.filter(el => el != this.#pageKey)
                localStorage.setItem('pageKeys', JSON.stringify(keys))
                if (this.#checkActiveTokenInterval) {
                    clearInterval(this.#checkActiveTokenInterval)
                    if (keys.length) {
                        localStorage.setItem('setCheckActiveTokenInterval', keys[0])
                    } else {
                        localStorage.removeItem('setCheckActiveTokenInterval')
                        this.setNoActiveServerToken()
                        localStorage.removeItem('isSendToken')
                    }
                }
            })
        }

        FcmNotify.funcChangeBtns(Notification.permission)
        if ('permissions' in navigator) {
            navigator.permissions.query({name:'notifications'}).then(function(permission) {
                permission.onchange = function() {
                    console.log("User decided to change his seettings. New permission: " + permission.state);
                    FcmNotify.funcChangeBtns(permission.state, true)
                };
            });
        }

        const getCookie = name=>{
            let matches = document.cookie.match(new RegExp(
                "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
            ));
            return matches ? decodeURIComponent(matches[1]) : undefined;
        }
        
        this.#pageKey = 'page_'+this.randKey()
        console.log(this.#pageKey)
        let keys = localStorage.getItem('pageKeys')
        keys = keys ? JSON.parse(keys) : []
        keys.push(this.#pageKey)
        localStorage.setItem('pageKeys', JSON.stringify(keys))

        if(!localStorage.getItem('setCheckActiveTokenInterval')){
            localStorage.setItem('setCheckActiveTokenInterval', this.#pageKey)
            clearInterval(this.#checkActiveTokenInterval)
            this.#checkActiveTokenInterval = setInterval(()=>{ 
                let lifetime = getCookie('bizbaby_session_lifetime')
                if(lifetime === undefined || (!isNaN(Number(lifetime)) && moment().unix() >= Number(lifetime))){
                    FcmNotify.setNoActiveServerToken()
                    localStorage.removeItem('isSendToken')
                }
                console.log('TICK INTERVAL')
            },5000)
        }
       
    }

    static async sendTokenToServer(token){
        const isSend = localStorage.getItem(`isSendToken`)
        if(isSend){
            let tokenSplit = isSend.split('{@}')
            const tokenSaved = tokenSplit[0]
            const organisationId = tokenSplit[1]
            if(token == tokenSaved && organisationId == window.organisation_id){
                return
            }
        }
        console.log('SEND TOKEN TO SERVER')
        $.ajax({
            url: `${location.origin}/set-fcm-token`,
            method: 'POST',
            dataType: 'json',
            data: {
                fcm_token:token,
                organisation_id:window.organisation_id,
                device_type: this.#DEVICE_TYPES.PC
            },  
            success: response=>{
                if(response?.success)
                    localStorage.setItem(`isSendToken`, `${token}{@}${window.organisation_id}`)
            },
            error: err=>{
                console.error(err)
            }
        }); 
    }
}

